<template>
    <div v-if="item">
        <div class="product__top-section">
            <h1 class="shop__heading product__mobile-heading" v-text="item.title"></h1>
            <image-carousel v-if="isMobile" :images="galleryImages" :altText="item.title"/>
            <image-gallery v-else :images="galleryImages" :altText="item.title"/>
            <product-information :item="item"></product-information>
        </div>
        <brochure-section v-if="item.info" :careInformation="item.info" :image="brochureImage" />
        <div class="product__top-section">
            <recommendations
                :className="'bestsellers'"
                :headerText="$t('RECOMMENDATIONS_BESTSELLERS_HEADER')"
                :subText="$t('RECOMMENDATIONS_BESTSELLERS_SUBTEXT')"
                :numItems="4"
                :excludeIds="[item.productId]"/>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ImageCarousel from '@/components/partials/account/shop/product-details/ImageCarousel';
import ImageGallery from '@/components/partials/account/shop/product-details/ImageGallery';
import ProductInformation from '@/components/partials/account/shop/product-details/ProductInformation';
import BrochureSection from '@/components/partials/account/shop/product-details/BrochureSection';
import Recommendations from '../../components/partials/account/shop/Recommendations.vue';

export default {
    name: 'ShopProductDetails',
    components: {
        BrochureSection,
        ImageGallery,
        ProductInformation,
        ImageCarousel,
        Recommendations,
    },
    computed: {
        ...mapGetters({
            getProductById: 'shop/getProductById',
        }),
        item() {
            return this.getProductById(this.productId);
        },
        galleryImages() {
            return this.item.images.gallery;
        },
        brochureImage() {
            return this.item.images.brochure.original;
        },
        isMobile() {
            return this.window.width < this.window.mobileBreakpoint;
        },
    },
    created() {
        this.$store.dispatch('shop/fetchProducts', { active_in: 'shop' });
    },
    data() {
        return {
            productId: null,
            window: {
                width: 0,
                mobileBreakpoint: 768,
            },
        };
    },
    mounted() {
        this.productId = Number(this.$route.params.productId);
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    methods: {
        handleResize() {
            this.window.width = window.innerWidth;
        },
    },
};
</script>
